import Config from '@/Config';
import { platform } from '@/Models';
import * as GamefoundContent from './PledgeManagerStaticContent.Gamefound.js';
import * as IdeafoundContent from './PledgeManagerStaticContent.Ideafound.js';

// Each platform's content lives in its own file since almost none of it is shared; only the matching one is used.
const content = Config.platform === platform.gamefound ? GamefoundContent : IdeafoundContent;

export const getStatistics = content.getStatistics;
export const getIntroductionStages = content.getIntroductionStages;
export const getExplanationSections = content.getExplanationSections;
export const getValues = content.getValues;
export const getSetupSteps = content.getSetupSteps;
export const getSetupStepsSummary = content.getSetupStepsSummary;
export const getWhyUsSections = content.getWhyUsSections;
export const getHelpCenterLinks = content.getHelpCenterLinks;
export const partnerLogos = content.partnerLogos;
export const getControlHighlights = content.getControlHighlights;
export const getComparisonRows = content.getComparisonRows;
export const getFaqItems = content.getFaqItems;
